/**
 * Marca + modelo mais vendidos no Brasil, carro e moto.
 *
 * Lista fechada, não um cadastro de fabricante: cobre o que roda de fato
 * nas ruas de uma cidade pequena do interior. Modelo raro demais para
 * estar aqui ainda pode ser digitado — o campo aceita texto livre, a
 * lista só acelera o caso comum.
 */
export const CAR_MODELS: readonly string[] = [
  // Chevrolet
  'Chevrolet Onix', 'Chevrolet Onix Plus', 'Chevrolet Prisma', 'Chevrolet Celta',
  'Chevrolet Corsa', 'Chevrolet Classic', 'Chevrolet Cobalt', 'Chevrolet Cruze',
  'Chevrolet Tracker', 'Chevrolet Spin', 'Chevrolet S10', 'Chevrolet Montana',
  'Chevrolet Astra', 'Chevrolet Vectra', 'Chevrolet Agile', 'Chevrolet Meriva',
  // Fiat
  'Fiat Uno', 'Fiat Palio', 'Fiat Siena', 'Fiat Grand Siena', 'Fiat Argo',
  'Fiat Cronos', 'Fiat Mobi', 'Fiat Strada', 'Fiat Toro', 'Fiat Punto',
  'Fiat Idea', 'Fiat Doblo', 'Fiat Fiorino', 'Fiat Linea', 'Fiat Bravo',
  'Fiat Pulse',
  // Volkswagen
  'Volkswagen Gol', 'Volkswagen Voyage', 'Volkswagen Fox', 'Volkswagen Polo',
  'Volkswagen Virtus', 'Volkswagen Saveiro', 'Volkswagen Up', 'Volkswagen Golf',
  'Volkswagen Jetta', 'Volkswagen Fusca', 'Volkswagen Parati', 'Volkswagen Santana',
  'Volkswagen Passat', 'Volkswagen T-Cross', 'Volkswagen Nivus', 'Volkswagen Amarok',
  'Volkswagen Kombi', 'Volkswagen Taos',
  // Ford
  'Ford Ka', 'Ford Fiesta', 'Ford Focus', 'Ford EcoSport', 'Ford Ranger',
  'Ford Fusion', 'Ford Courier', 'Ford Escort', 'Ford Corcel', 'Ford Belina',
  'Ford Territory',
  // Hyundai
  'Hyundai HB20', 'Hyundai HB20S', 'Hyundai Creta', 'Hyundai Tucson',
  'Hyundai Elantra', 'Hyundai Azera', 'Hyundai ix35', 'Hyundai i30',
  'Hyundai Santa Fe',
  // Toyota
  'Toyota Corolla', 'Toyota Corolla Cross', 'Toyota Etios', 'Toyota Yaris',
  'Toyota Hilux', 'Toyota SW4', 'Toyota RAV4',
  // Renault
  'Renault Sandero', 'Renault Logan', 'Renault Kwid', 'Renault Duster',
  'Renault Captur', 'Renault Clio', 'Renault Symbol', 'Renault Fluence',
  'Renault Oroch',
  // Honda
  'Honda Civic', 'Honda Fit', 'Honda City', 'Honda HR-V', 'Honda WR-V',
  'Honda CR-V', 'Honda Accord',
  // Nissan
  'Nissan March', 'Nissan Versa', 'Nissan Kicks', 'Nissan Sentra',
  'Nissan Frontier', 'Nissan Livina',
  // Jeep
  'Jeep Renegade', 'Jeep Compass', 'Jeep Commander',
  // Citroën
  'Citroën C3', 'Citroën C4 Cactus', 'Citroën C4 Lounge', 'Citroën Aircross',
  // Peugeot
  'Peugeot 208', 'Peugeot 2008', 'Peugeot 3008', 'Peugeot 207', 'Peugeot 307',
  // Mitsubishi
  'Mitsubishi L200', 'Mitsubishi ASX', 'Mitsubishi Pajero', 'Mitsubishi Outlander',
  'Mitsubishi Eclipse Cross',
  // Kia
  'Kia Picanto', 'Kia Rio', 'Kia Sportage', 'Kia Cerato', 'Kia Soul',
  // Suzuki
  'Suzuki Jimny', 'Suzuki Vitara', 'Suzuki Swift',
  // Chery / Caoa Chery
  'Chery Tiggo', 'Chery QQ', 'Chery Celer', 'Chery Arrizo',
  // JAC
  'JAC T40', 'JAC T50', 'JAC T60', 'JAC iEV',
  // BYD
  'BYD Dolphin', 'BYD Song', 'BYD Yuan', 'BYD King',
  // GWM
  'GWM Haval H6', 'GWM Ora',
  // Premium
  'BMW 320i', 'BMW X1', 'BMW X3', 'Mercedes-Benz C180', 'Mercedes-Benz GLA',
  'Mercedes-Benz Classe A', 'Audi A3', 'Audi Q3', 'Volvo XC40', 'Volvo XC60',
  'Land Rover Evoque', 'Mini Cooper',
] as const;

export const MOTO_MODELS: readonly string[] = [
  // Honda
  'Honda CG 160', 'Honda CG Titan', 'Honda Biz 125', 'Honda Pop 110i',
  'Honda Bros 160', 'Honda Fan 160', 'Honda Titan', 'Honda XRE 300',
  'Honda CB 300', 'Honda CB 500', 'Honda PCX', 'Honda Elite 125',
  'Honda Twister', 'Honda Lead 110', 'Honda NXR 160',
  // Yamaha
  'Yamaha Fazer 250', 'Yamaha Factor 150', 'Yamaha Crosser 150',
  'Yamaha Lander 250', 'Yamaha NMax', 'Yamaha XTZ 150', 'Yamaha Fluo',
  'Yamaha MT-03', 'Yamaha YBR 150',
  // Suzuki
  'Suzuki Yes 125', 'Suzuki GSR 150', 'Suzuki Intruder',
  // Kawasaki
  'Kawasaki Ninja 300', 'Kawasaki Z400',
  // Shineray
  'Shineray SHI 175', 'Shineray XY 50', 'Shineray Jet 50',
  // Haojue
  'Haojue DK 150', 'Haojue NK 150',
  // Dafra
  'Dafra Citycom', 'Dafra Next 300', 'Dafra Speed 150',
  // Sundown
  'Sundown Web 100', 'Sundown Prime 160',
  // Traxx
  'Traxx TR 125',
  // BMW
  'BMW G 310', 'BMW F 850 GS',
] as const;

export function searchVehicleModels(type: 'car' | 'moto', query: string): string[] {
  const list = type === 'car' ? CAR_MODELS : MOTO_MODELS;
  return filterOptions(list, query);
}

/** Cores do CRLV — o rótulo que o Detran usa, não o nome comercial da tinta. */
export const VEHICLE_COLORS: readonly string[] = [
  'Branca', 'Preta', 'Prata', 'Cinza', 'Vermelha', 'Azul', 'Verde',
  'Amarela', 'Marrom', 'Bege', 'Dourada', 'Laranja', 'Roxa', 'Rosa',
  'Vinho', 'Grafite', 'Fosca',
] as const;

export function filterOptions(list: readonly string[], query: string): string[] {
  const q = query.trim().toLowerCase();
  if (!q) return [...list].slice(0, 30);
  return list.filter((m) => m.toLowerCase().includes(q)).slice(0, 30);
}
